var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindshield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.389 13.91a.73.73 0 00-.979.326l-1.458 2.917a.73.73 0 101.305.652l1.458-2.917a.73.73 0 00-.326-.978zm2.916 0a.73.73 0 00-.978.326L8.41 20.069a.73.73 0 101.305.653l2.916-5.834a.73.73 0 00-.326-.978z",
    fill: "var(--color-secondary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.317 14.079c-.064-.073-1.607-1.79-4.835-3.386a.732.732 0 00-.884.187l-2.68 3.215a.728.728 0 00-.13.698l1.315 3.947-1.872 1.873.481-1.445a.73.73 0 00-.085-.635l-2.681-4.023 2.268-4.538a.73.73 0 00-.469-1.031C25.335 8.316 22.73 8 20 8 8.139 8 2.898 13.834 2.68 14.082a.729.729 0 00-.154.672L6.9 30.796c.064.234.24.42.47.497.228.08.484.037.677-.11.036-.028 3.732-2.766 11.952-2.766 8.22 0 11.916 2.738 11.952 2.766a.736.736 0 00.677.11.728.728 0 00.47-.497l4.375-16.042a.73.73 0 00-.157-.675zM31.95 29.467c-1.61-.887-5.44-2.509-11.95-2.509-6.51 0-10.34 1.622-11.95 2.509L4.042 14.774C5.204 13.659 10.232 9.458 20 9.458c2.276 0 4.457.23 6.5.683l-2.048 4.095a.73.73 0 00.045.731l2.719 4.078-1.345 4.037a.729.729 0 001.207.746l4.375-4.375a.729.729 0 00.176-.746l-1.33-3.99 2.047-2.455c1.922 1.017 3.113 2.041 3.61 2.515l-4.006 14.69z",
    fill: "var(--color-secondary)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindshield);
export default __webpack_public_path__ + "static/media/windshield.a5529115dac9efda80d9ce7d77388c92.svg";
export { ForwardRef as ReactComponent };